import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useCallback, useEffect, useContext } from "react";
import "../index.css";
import { Link, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import EditIcon from "@mui/icons-material/Edit";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import Person4Icon from "@mui/icons-material/Person4";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIosNew";
import axios from "axios";
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
import translations from "./translation";

const Learn = () => {
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState("Learning");
  const { quizTypes, Translate, Universitydata, Leveldata } = useContext(ProductContext);
  const selectedLanguage = localStorage.getItem("selectedLanguage") || "hindi";
  const localTranslations = translations[selectedLanguage === "hindi" ? "hindi" : "english"];

  const getLocalizedQuizName = (name, lang) => {
    const isHindi = lang === "hindi";
    const nameLower = String(name || "").trim().toLowerCase();
    
    if (nameLower.includes("listening")) {
      return isHindi ? "सुनने संबंधी प्रश्नोत्तरी" : "Listening Quiz";
    }
    if (nameLower.includes("writing")) {
      return isHindi ? "लिखने का अभ्यास" : "Writing Quiz";
    }
    if (nameLower.includes("hiragana")) {
      return isHindi ? "हीरागाना क्विज़" : "Hiragana Quiz";
    }
    if (nameLower.includes("katakana")) {
      return isHindi ? "काटाकाना क्विज़" : "Katakana Quiz";
    }
    if (nameLower.includes("kanji")) {
      return isHindi ? "कांजी क्विज़" : "Kanji Quiz";
    }
    if (nameLower.includes("vocab") || nameLower.includes("vocabulary")) {
      return isHindi ? "शब्दावली क्विज़" : "Vocab Quiz";
    }
    if (nameLower.includes("grammar")) {
      return isHindi ? "व्याकरण क्विज़" : "Grammar Quiz";
    }
    if (nameLower.includes("life in japan") || nameLower.includes("जापान")) {
      return isHindi ? "जापान में जीवन (स्किट)" : "Life in Japan (Skit)";
    }
    if (nameLower.includes("manga") || nameLower.includes("मांगा")) {
      return isHindi ? "मांगा (जापानी हास्य)" : "Manga";
    }
    return name;
  };
  // const { Translate } = useContext(ProductContext);
  const authToken = localStorage.getItem("AuthToken");
  const [hasActiveSubscription, setHasActiveSubscription] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCouponModalOpen, setIsCouponModalOpen] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [selectedUniversity, setSelectedUniversity] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [hasAccessOverride, setHasAccessOverride] = useState(
    localStorage.getItem("couponVerified") === "true"
  );

  console.log(quizTypes, "quizTypes Learn")

  const fetchUserSubscription = useCallback(async () => {
    try {
      const response = await axios.get("https://api.japaking.online/api/user-subscription", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response?.data?.success) {
        const plans = response?.data?.message?.plan;
        const now = new Date();
        const hasPlan = Array.isArray(plans) && plans.some((p) => {
          const activity = p.Activity_Status ? String(p.Activity_Status).toLowerCase() : "";
          return activity === "active" || 
                 activity === "trial" || 
                 activity === "trail" || 
                 (new Date(p.start_date) <= now && new Date(p.end_date) >= now && p.status === "active");
        });
        setHasActiveSubscription(hasPlan);
        return;
      }

      setHasActiveSubscription(false);
    } catch (error) {
      console.error("Error fetching user-subscription in Learn:", error);
      setHasActiveSubscription(false);
    }
  }, [authToken]);

  useEffect(() => {
    if (authToken) {
      fetchUserSubscription();
    }
  }, [authToken, fetchUserSubscription]);

  const hasCredits = hasActiveSubscription;
  const canAccessTiles = hasCredits || hasAccessOverride;
  const listeningQuizTile = {
    quiz_type_id: 11,
    quiz_type_name: "Listening Quiz",
    isVirtualTile: true,
  };

  const quizTiles = [];
  let listeningTileInserted = false;

  quizTypes.forEach((quiz) => {
    quizTiles.push(quiz);

    if (
      !listeningTileInserted &&
      String(quiz?.quiz_type_name || "").toLowerCase() === "kanji quiz"
    ) {
      quizTiles.push(listeningQuizTile);
      listeningTileInserted = true;
    }
  });

  if (!listeningTileInserted) {
    quizTiles.push(listeningQuizTile);
  }

  const handleLockedAccess = () => {
    setIsModalOpen(true);
  };

  const handleLearningMaterialClick = () => {
    if (!canAccessTiles) {
      handleLockedAccess();
      return;
    }
    navigate("/LearningMaterials");
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsCouponModalOpen(false);
  };

  const openCouponModal = () => {
    setIsCouponModalOpen(true);
  };

  const verifyCoupon = useCallback(async () => {
    try {
      const response = await fetch(`https://api.japaking.online/api/coupon/subscribe`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          couponCode: couponCode.trim(),
          college_name: selectedUniversity,
          exam_type: selectedLevel,
        }),
      });

      const result = await response.json();

      if (response.ok && result?.message?.success) {
        localStorage.setItem("couponVerified", "true");
        setHasAccessOverride(true);
        setIsModalOpen(false);
        setIsCouponModalOpen(false);
        alert("Coupon Applied Successfully!");
      } else {
        alert("Incorrect Coupon Code or Exam Type");
      }
    } catch (error) {
      console.error("Error verifying coupon in Learn:", error);
    }
  }, [authToken, couponCode, selectedUniversity, selectedLevel]);

  return (
    <div className="Profile_Design_Main_Div_11">
      <div className="header_inner">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ArrowBackIosIcon
                onClick={() => navigate("/")}
                className="icon_1"
              />
              <h2>{Translate?.message?.data?.quizType || localTranslations?.quizType || "Quiz Type"}</h2>
              <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
            </div>
          </div>
        </div>
      </div>
      <div className="learn-container1">
        <div className="container">
          <div className="row justify-content-start">
            <div className="col-6 col-sm-3 col-md-3 col-lg-3">
                <div
                  className="learn_box"
                  style={{
                    opacity: canAccessTiles ? 1 : 0.7,
                    cursor: canAccessTiles ? "pointer" : "not-allowed",
                    position: "relative",
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/newQuixImage.jpeg`}
                    alt="notFound"
                    className="learning_img"
                    onClick={handleLearningMaterialClick}
                  />
                   {!canAccessTiles && (
                    <div
                      style={{
                        position: "absolute",
                        top: "8px",
                        right: "8px",
                        background: "rgba(0, 0, 0, 0.75)",
                        color: "#fff",
                        fontSize: "10px",
                        lineHeight: "1.2",
                        padding: "4px 6px",
                        borderRadius: "6px",
                        maxWidth: "120px",
                        textAlign: "right",
                        pointerEvents: "none",
                      }}
                    >
                      No credits left, pay to study
                    </div>
                  )}
                  <h1 className="learn-box-heading">{Translate?.message?.data?.LearningMaterials || localTranslations?.learning || "Study Material"}</h1>
                 
                </div>
              </div>
            {quizTiles.map((quiz, index) => (
              <div className="col-6 col-sm-3 col-md-3 col-lg-3" key={index}>
                <div
                  className="learn_box"
                  style={{
                    opacity: canAccessTiles ? 1 : 0.7,
                    cursor: canAccessTiles ? "pointer" : "not-allowed",
                    position: "relative",
                  }}
                  onClick={() => {
                    if (!canAccessTiles) {
                      handleLockedAccess();
                      return;
                    }
                    if (quiz.isVirtualTile) {
                      navigate(`/JLPTQuiz`, {
                        state: {
                          quizTypeId: 11,
                          quizName: "Listening Quiz",
                          quiz_name: "Listening Quiz",
                          quiz_id: 11,
                          openListeningSelection: true,
                        },
                      });
                      return;
                    }
                    const quizData = {
                      quiz_name: quiz.quiz_type_name,
                      quiz_id: quiz.quiz_type_id,
                    };

                    console.log(
                      "quiz name:",
                      quiz.quiz_type_name,
                      "quiz ID:",
                      quiz.quiz_type_id
                    );

                    // Check if the quiz type is either 'Life in Japan (Skit)' or 'जापान मैं जीवन'
                    if (
                      quiz.quiz_type_name === "Life in Japan (Skit)" ||
                      quiz.quiz_type_id === "जापान मैं जीवन" ||
                      quiz.quiz_type_id === 9
                    ) {
                      navigate(`/LifeInJapan`, { state: quizData });
                    }
                    // Check if the quiz type is either 'मांगा (जापानी हास्य)' or 'Manga'
                    else if (
                      quiz.quiz_type_name === "मांगा (जापानी हास्य)" ||
                      quiz.quiz_type_name === "Manga" ||
                      quiz.quiz_type_id === 10
                    ) {
                      navigate(`/Manga`, { state: quizData });
                    }
                    // Default navigation to JLPTQuiz
                    else {
                      navigate(`/JLPTQuiz`, { state: quizData });
                    }
                  }}
                >
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/newQuixImage.jpeg`}
                    alt="notFound"
                    className="learning_img"
                  />
                   {!canAccessTiles && (
                    <div
                      style={{
                        position: "absolute",
                        top: "8px",
                        right: "8px",
                        background: "rgba(0, 0, 0, 0.75)",
                        color: "#fff",
                        fontSize: "10px",
                        lineHeight: "1.2",
                        padding: "4px 6px",
                        borderRadius: "6px",
                        maxWidth: "120px",
                        textAlign: "right",
                        pointerEvents: "none",
                      }}
                    >
                      No credits left, pay to study
                    </div>
                  )}
                  <h1 className="learn-box-heading">{getLocalizedQuizName(quiz.quiz_type_name, selectedLanguage)}</h1>
                 
                </div>
              </div>
            ))}
            <div className="col-6 col-sm-3 col-md-3 col-lg-3">
              <div
                className="learn_box"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/study-job-in-japan")}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/journy1.jpg`}
                  alt="Study in Japan"
                  className="learning_img"
                />
                 <h1 className="learn-box-heading">{Translate?.message?.data?.studyInJapan || localTranslations?.studyInJapan || "Study in Japan"}</h1>
              </div>
            </div>
            <div className="col-6 col-sm-3 col-md-3 col-lg-3">
              <div
                className="learn_box"
                style={{ cursor: "pointer" }}
                onClick={() => navigate("/study-job-in-japan")}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/bus.jpg`}
                  alt="Discover Job Opportunities"
                  className="learning_img"
                />
                 <h1 className="learn-box-heading">{Translate?.message?.data?.discoverJobOpportunities || localTranslations?.discoverJobOpportunities || "Discover Job Opportunities"}</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

            <Footer />
      {!canAccessTiles && isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <span onClick={closeModal} className="close-icon">×</span>
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/learning4.jpg`}
              className="modal-image"
              alt="subscription"
            />
            <button className="pay-now-btn" onClick={() => navigate(window.ReactNativeWebView ? "/AppView" : "/plans")}>
              Pay Now
            </button>
            <div className="line-with-text">Apply Coupon</div>
            <button className="coupon-code-btn" onClick={openCouponModal}>
              Coupon Code
            </button>
          </div>
        </div>
      )}
      {isCouponModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <span onClick={closeModal} className="close-icon">×</span>
            <h5>Details</h5>
            <label>Universities:</label>
            <select
              className="dropdown"
              value={selectedUniversity}
              onChange={(e) => setSelectedUniversity(e.target.value)}
            >
              <option value="">Select University</option>
              {(Universitydata || []).map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
            <label>Level:</label>
            <select
              className="dropdown"
              value={selectedLevel}
              onChange={(e) => setSelectedLevel(e.target.value)}
            >
              <option value="">Select Level</option>
              {(Leveldata || []).map((item, index) => (
                <option key={index} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
            <label>Coupon Code:</label>
            <input
              type="text"
              className="coupon-code-input"
              placeholder="Enter coupon code"
              value={couponCode}
              onChange={(e) => setCouponCode(e.target.value)}
            />
            <button className="submit-btn" onClick={verifyCoupon}>
              Submit
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Learn;
